module.exports = __webpack_public_path__ + "img/laboBrown.42904fa5.svg";